









































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { FindCarrinhoUseCase } from '@/usecases/venda/FindCarrinhoUseCase'
import { Carrinho } from '@/models/venda/Carrinho'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import DialogoDeEdicaoDeCarrinho from './DialogoDeEdicaoDeCarrinho.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import axios, { CancelTokenSource } from 'axios'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { obterDisplayClienteDoCarrinho } from '@/shareds/venda-shareds'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { Cliente } from '@/models'


@Component({
	components: {
		SeletorDeLojasDoUsuario,
		RangeDatePicker,
		DataTableDeCrud,
		Confirmacao,
		SeletorDeUsuario,
		DialogoDeEdicaoDeCarrinho,
		SeletorDeCliente,
	},
})
export default class TelaDeMontagemDeCarrinho extends Vue {
	@Ref() dialogoDeConfirmacao!: Confirmacao
	@Ref() dialogoDeEdicaoDeCarrinho!: DialogoDeEdicaoDeCarrinho

	findCarrinhoUseCase = new FindCarrinhoUseCase()

	tab = 0
	tabs = ['Malinhas']
	buscandoGerais = false
	vendedores: Array<{ id: string; nome: string }> = []
	carregandoVendedores = false
	malinhas: Carrinho[] = []
	carregandoMalinha = false
	pedidos: Carrinho[] = []
	carregandoPedido = false	
	totalMalinhas = 0
	totalPedidos = 0
	carrinho: Carrinho | null = null
	editando = false
	cancelToken: CancelTokenSource | null = null

	paginacaoMalinha: any = {
		page: 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
	}
	
	paginacaoPedido: any = {
		page: 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
	}

	filtroGerais: FiltroGerais = {
		lojaId: null,
		vendedorId: null,
		identificador: null,
		tipo: '',
		cliente: null,
	}

	headers = [
		{ text: 'Identificador', value: 'identificador' },
		{ text: 'Loja', value: 'loja.nomeFantasia' },
		{ text: 'Vendedor', value: 'vendedor.nome' },
		{ text: 'Cliente', value: 'displayCliente' },
		{ text: 'Data e hora', value: 'dataHoraCriacao' },
		{ text: 'Link', value: 'link' },
		{ text: 'Status', value: 'status' },
		{ text: 'Identificador da Venda', value: 'venda.identificador' },
	]

	get temFiltroGeral() {
		const { lojaId, vendedorId, identificador } = this.filtroGerais
		return !!(lojaId || vendedorId || identificador)
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	limparFiltrosGerais() {
		this.filtroGerais.identificador = null
		this.filtroGerais.vendedorId = null
		this.filtroGerais.lojaId = null
		this.filtroGerais.cliente = null

		this.aplicarFiltrosGerais()
	}

	async aplicarFiltrosGerais() {
		this.buscandoGerais = true

		try {
			await Promise.all([this.buscarMalinhas(), this.buscarPedidos()])
		} finally {
			this.buscandoGerais = false
		}
	}

	@Watch('paginacaoMalinha', { deep: true })
	async onPaginacaoMalinhaChange() {
		await this.buscarMalinhas()
	}

	@Watch('paginacaoPedido', { deep: true })
	async onPaginacaoPedidoChange() {
		await this.buscarPedidos()
	}

	@Watch('filtroGerais.lojaId')
	onLojaIdChange() {
		this.filtroGerais.vendedorId = null
	}

	montarParamsComuns() {
		const { lojaId, vendedorId, identificador, tipo, cliente } = this.filtroGerais
		return {
			lojaId,
			vendedorId,
			identificador,
			tipo,
			clienteId: cliente ? cliente.id : null,
		}
	}

	montarParamsPaginacao(paginacao: any) {
		return {
			page: paginacao.page - 1, 
			size: paginacao.itemsPerPage,
			sortBy: paginacao.sortBy?.[0],
			sortDir: paginacao.sortDesc?.[0] ? 'DESC' : 'ASC',
		}
	}

	async buscarMalinhas() {
		this.carregandoMalinha = true
		this.cancelToken = axios.CancelToken.source()

		try {
			this.filtroGerais.tipo = 'MALINHA'

			const params = {
				...this.montarParamsComuns(),
				...this.montarParamsPaginacao(this.paginacaoMalinha),
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.findCarrinhoUseCase.findCarrinhosByTipo(params, axiosConfig)
			this.malinhas = page.content || []
			this.totalMalinhas = page.totalElements || this.malinhas.length
		} catch (e) {
			this.malinhas = []
			this.totalMalinhas = 0
		} finally {
			this.carregandoMalinha = false
		}
	}

	async buscarPedidos() {
		this.carregandoPedido = true
		this.cancelToken = axios.CancelToken.source()

		try {
			this.filtroGerais.tipo = 'PEDIDO'
			const params = {
				...this.montarParamsComuns(),
				...this.montarParamsPaginacao(this.paginacaoPedido),
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const page = await this.findCarrinhoUseCase.findCarrinhosByTipo(params, axiosConfig)
			this.pedidos = page.content || []
			this.totalPedidos = page.totalElements || this.pedidos.length
		} catch (e) {
			this.pedidos = []
			this.totalPedidos = 0
		} finally {
			this.carregandoPedido = false
		}
	}

	abrirDialogoDeEditarPedido(indice: number) {
		try {
			if (!this.temRecurso('alterar', 'carrinhos')) {
				throw new Error('Necessário permissão para editar')
			}
			this.editando = true
			this.carrinho = this.pedidos[indice]
			
			this.dialogoDeEdicaoDeCarrinho.mostrar(true, this.carrinho)
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeEditarMalinha(indice: number) {
		try {
			if (!this.temRecurso('alterar', 'carrinhos')) {
				throw new Error('Necessário permissão para editar')
			}
			this.editando = true
			this.carrinho = this.malinhas[indice]

			this.dialogoDeEdicaoDeCarrinho.mostrar(true, this.carrinho)
			
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	removerPedido(indice: number) {
		const pedido = this.pedidos[indice]
		if (!pedido) return
			(this.$refs.dialogoConfirmacaoPedido as any).abrir?.(pedido)
	}

	removerMalinha(indice: number) {
		const malinha = this.malinhas[indice]
		if (!malinha) return
		(this.$refs.dialogoConfirmacaoMalinha as any).abrir?.(malinha)
	}

	abrirDialogoDeCriarCarrinho(){
		try {
			if (!this.temRecurso('criar', 'carrinhos')) {
				throw new Error('Necessário permissão para criar')
			}

			this.editando = true
			this.carrinho = {
				id: '',
				tipoDoCarrinho: '',
				link: '',
				vendedor: null,
				identificador: '',
				valorTotal: 0,
				informacoesDeTransporte: {
					modalidadeDeFrete: 'Sem Frete',
					especie: null,
					pesoBruto: null,
					pesoLiquido: null,
					volume: null,
					fornecedor: null,
					valorFrete: null,
					codigoRastreio: null,
					tipoDeFrete: null,
				},
				loja: null,
				quantidadeDePecas: 0,
				itens: [],
				cliente: null,
				status: 'Pendente',
				venda: null,
				dataHoraCriacao: null,
				movimentouEstoque: false,
			}

			this.dialogoDeEdicaoDeCarrinho.mostrar(false, this.carrinho)

		} catch (error){
			AlertModule.setError(error)
		}
	}

	async atualizarPagina(tipoDoCarrinho){
		if (tipoDoCarrinho === 'Malinha'){
			await this.buscarMalinhas()
		} else {
			await this.buscarPedidos()
		}
	}

	copiarLinkMalinhas(indice: number) {
		const carrinho = this.malinhas[indice]
		if (!carrinho) return

		this.copiarTexto(carrinho.link || '')
	}

	copiarTexto(texto: string) {
		if (!texto) {
			AlertModule.setError('Carrinho não possui link para copiar.')
			return
		}

		const navQualquer = navigator as any
		if (navQualquer.clipboard && typeof navQualquer.clipboard.writeText === 'function') {
			navQualquer.clipboard.writeText(texto)
				.then(() => {
					AlertModule.setSuccess('Link copiado para a área de transferência')
				})
				.catch(() => {
					AlertModule.setError('Não foi possível copiar o link')
				})
			return
		}

		try {
			const textarea = document.createElement('textarea')
			textarea.value = texto
			textarea.setAttribute('readonly', '')
			textarea.style.position = 'absolute'
			textarea.style.left = '-9999px'
			document.body.appendChild(textarea)
			textarea.select()
			const sucesso = document.execCommand('copy')
			document.body.removeChild(textarea)

			if (sucesso) {
				AlertModule.setSuccess('Link copiado para a área de transferência')
			} else {
				AlertModule.setError('Não foi possível copiar o link')
			}
		} catch (e) {
			AlertModule.setError('Não foi possível copiar o link')
		}
	}

	atualizarMalinhas(carrinhoAtualizado: Carrinho) {
		const indiceDaVenda = this.malinhas.findIndex(
			({ id }) => id === carrinhoAtualizado.id,
		)
		this.malinhas.splice(indiceDaVenda, 1, carrinhoAtualizado)
	}

	get malinhasFormatadas() {
		return this.malinhas.map(malinha => ({
			...malinha,
			dataHoraCriacao: malinha.dataHoraCriacao 
				? dateTimeToPtBrFormat(malinha.dataHoraCriacao) 
				: '---',
			displayCliente: obterDisplayClienteDoCarrinho(malinha),
		}))
	}

	async irParaVendaOrigem(indice: number){
		const malinha = this.malinhas[indice]
		if (!malinha.venda) return AlertModule.setError("Malinha possui faturamento pendente, ainda não há venda emitida.")
		if (this.temRecurso('ler', 'vendas')) {
			window.open(`/vendas?identificador=${malinha.venda.identificador}`, '_blank')
		}
	}

	podeRedirecionarVenda(item: Carrinho) {
		return !!item.venda && item.status === 'Concluido'
	}

	iconeAlterarMalinha(item: Carrinho) {
		return item.status === 'Concluido' ? 'mdi-eye' : 'mdi-pencil'
	}

}

type FiltroGerais = {
	lojaId: string | null
	vendedorId: string | null
	identificador: string | null
	tipo: string
	cliente: Cliente | null
}


